import { endorsementFieldNoun } from '@features/activity/copy';

import { bold, NameList, Summary } from './primitives';
import type { SummarySlice } from './types';

export const endorsementSummaries = {
  'endorsement.raised': ({ entry, ctx }) => {
    if (ctx.isEndorsementSummaryView) return <div>Endorsement raised</div>;
    return (
      <Summary>Endorsement created{entry.parentName ? <>&nbsp;from&nbsp;{bold(entry.parentName)}</> : null}</Summary>
    );
  },
  'endorsement.details_edited': ({ entry }) => (
    <Summary>
      <NameList names={entry.fields.map((field) => endorsementFieldNoun(field, entry.premiumChange))} />
      &nbsp;edited
    </Summary>
  ),
  'endorsement.duplicated': ({ entry }) => (
    <Summary>Endorsement duplicated to:&nbsp;{bold(entry.targetEntity.name ?? entry.targetEntity.id)}</Summary>
  ),
  'endorsement.duplicated_from': ({ entry }) => (
    <Summary>
      Endorsement:&nbsp;{bold(entry.sourceEndorsement.name)} duplicated from:&nbsp;
      {bold(entry.sourceContract.name)}
    </Summary>
  ),
  'endorsement.merged': ({ entry }) => (
    <Summary>Endorsement:&nbsp;{bold(entry.endorsement.name)} merged into this contract</Summary>
  ),
} satisfies SummarySlice;
